import React, { useEffect, useRef } from "react";
import "../../lease/LeasesPage.css";

/** Small delete confirmation (the only popup left in the Network / Team modules). */
const DeleteConfirmDialog = ({ title, message, busy, confirmLabel = "Delete", onCancel, onConfirm }) => {
  const cancelRef = useRef(null);

  useEffect(() => {
    cancelRef.current?.focus();
    const onKeyDown = (e) => {
      if (e.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [busy, onCancel]);

  return (
    <div className="lease-confirm-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="lease-confirm">
        <h5 className="fw-bold">{title}</h5>
        <p className="text-muted mb-4">{message}</p>
        <div className="d-flex justify-content-end gap-2">
          <button ref={cancelRef} type="button" className="btn btn-outline-secondary" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={busy}>
            {busy ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmDialog;
